<script lang="typescript">
  import { useMachine } from '@xstate/svelte';
  import Panel from '../../common/Panel.svelte';
  import JitsiVideoMeeting from '../jitsi/JitsiVideoMeeting.svelte';
  import { createMachine, INDICATOR_RESOLUTION } from './machine';
  import { describeArc } from './svgarc';
  import type { ClientMeetingInfo } from '../../common/types';
  export let meetingInfo:ClientMeetingInfo;
  export let feedbackUrl:string;
  const machine = createMachine(meetingInfo, feedbackUrl);
  const { send, state } = useMachine(machine);
  const join = () => send('JOIN');
  const leave = () => send('LEAVE');
  const feedback = () => send('FEEDBACK');
  const options = {
    configOverwrite: {
      defaultLanguage: 'fi',
      startWithAudioMuted: false,
      toolbarButtons: [
        'microphone',
        'camera',
        'fullscreen',
        'hangup',
        'raisehand',
        'tileview',
        'select-background',
      ],
      hideConferenceTimer: true,
      hideConferenceSubject: true,
    },
  };
  $: indicator = $state.context.indicator;
  $: title = $state.context.meetingInfo.title;
  $: jwt = $state.context.meetingInfo.jwt;
  $: roomName = $state.context.meetingInfo.jaas_room_name;
  $: waitingForSupervisor = $state.matches('waiting_to_start');
  $: showVideo = 
  [ 'in_progress.meeting.not_joined',
    'in_progress.meeting.joined',
  ].some($state.matches);
  $: isHangup = $state.matches('in_progress.meeting.hangup');
  $: isFinished = $state.matches('finished');
  $: isCancelled = $state.matches('cancelled');
  $: isFirstTime = $state.matches('in_progress.meeting.not_joined.first_time');
  $: isPreviouslyJoined = $state.matches('in_progress.meeting.not_joined.previously_joined');
  $: isFeedback = $state.matches('feedback');
  $: isJoined = $state.matches('in_progress.meeting.joined');
  $: error = $state.context.error;
  $: path = describeArc(50, 50, 50, 0, 360 * indicator / INDICATOR_RESOLUTION);

</script>

<div id="videomeeting">

  {#if showVideo && roomName}
    <div id="video">
      <JitsiVideoMeeting {jwt} {roomName} {options} on:join={join} on:leave={leave} />
    </div>
  {/if}

  <div class="info">

    {#if isJoined}
      <div>
        <p>Olet liittyneenä Nemonetti-videotapaamiseen.</p>
      </div>
    {/if}

    {#if waitingForSupervisor}
      <div>
        <h3>{title}</h3>
        <p>Odotetaan että ohjaaja liittyy tapaamiseen.</p>
        <svg height="100" width="100" fill="#28bbe5">
          <path d="{path}" />
        </svg>
      </div>
    {/if}

    {#if error}
      <div>
        <Panel type="error">
        <p>Tapaamisen statuksen päivityksessä tapahtui virhe.</p>
        {@html error}
        </Panel>
      </div>
    {/if}

    {#if isFirstTime}
      <div>
        <p>Pääset mukaan tapaamiseen antamalla haluamasi kutsumanimen ja painamalla liittymisnappia.</p>
      </div>
    {/if}

    {#if isPreviouslyJoined}
      <div>
        <h3>{title}</h3>
        <p>Oletkin jo aikaisemmin liittynyt käynnissä olevaan tapaamiseen. Toivottavasti ei ole teknisiä ongelmia...
        <p>Pääset mukaan tapaamiseen antamalla haluamasi kutsumanimen ja painamalla liittymisnappia.</p>
      </div>
    {/if}

    {#if isHangup}
      <div>
        <h3>{title}</h3>
        <p>Poistuit tapaamisesta. Toivottavasti kaikki meni hyvin.</p>
        <p>Voit antaa palautetta heti tai vasta myöhemmin kun olet hieman levännyt. Joskus tapaamiset voivat yllättävästi myöskin väsyttää.</p>
        <p>
        <button on:click={feedback}>Anna palautetta</button>
        </p>
        <p>Jos poistuit vahingossa tapaamisesta ja haluat palata takaisin tapaamiseen niin paina alla olevaa nappia.</p>
        <p>
        <button on:click={join}>Liity takaisin tapaamiseen</button>
        </p>
      </div>
    {/if}

    {#if isFinished}
      <div>
        <h3>{title}</h3>
        <p>Tapaaminen on ohi. Toivottavasti tapaaminen oli onnistunut.</p>
        <p>Voit antaa palautetta heti tai myöhemmin kun olet hieman levännyt. Joskus tapaamiset voivat yllättävästi myöskin väsyttää.</p>
        <p>
        <button on:click={feedback}>Siirry antamaan palautetta</button>
        </p>
      </div>
    {/if}

    {#if isFeedback}
      <div>
        <h3>{title}</h3>
        <p>
        <i class="fas fa-spinner fa-spin"></i>
        Siirrytään palautesivulle...
        </p>
      </div>
    {/if}

    {#if isCancelled}
      <div>
        <h3>{title}</h3>
        <p>Voi harmi. Tapaaminen on peruttu</p>

        <p>Jos olet maksanut tapaamisen olet jo varmaankin saanut hyvityskoodin
        sähköpostiisi. Hyvityskoodilla voit maksaa seuraavan vastaavan
        tapaamisen.</p>

      </div>
    {/if}

    {#if isPreviouslyJoined}
      <div>
        <p>Jos tapaaminen on jo päättynyt voit siirtyä antamaan palautetta alla olevaa nappia painamalla.</p>
        <p>
        <button on:click={feedback}>Anna palautetta</button>
        </p>
      </div>
    {/if}

  </div>
</div>

<style>
  #videomeeting {
    height: 100%;
    /*
    display: flex;
    flex-direction: column;
    */
  }

  .info {
    margin: 0 32px 0 32px;
  }

  .info div:first-child {
    margin-top: 24px;
  }

</style>
